import { create } from "zustand";

// 본부 및 지점 콤보
const baseHQBranchCombo = {
  selected_branch_info: {
    branch_id: "",
    branch_name: "",
  },
  selected_hq_info: {
    hq_id: "",
    hq_name: "",
  },
  data: [
    {
      branch_name_list: [""],
      hq_info: {
        hq_id: "",
        hq_name: "",
      },
      branch_list: [""],
      branch_all_info: {
        branch_name: "전체",
        branch_ids: [""],
      },
    },
  ],
  hq_list: [""],
};

const baseSearchParams = {
  branch_ids: [""],
  end_date: "",
  hq_ids: [""],
  operator: "",
  page_number: 1,
  page_size: 10,
  sort_direction: -1,
  sort_key: "reg_date",
  start_date: "",
  transaction_type: "",
};

export const useVaultCashStore = create((set) => ({
  // ========== State ===========
  vaultCashHQBranchCombo: {
    ...baseHQBranchCombo,
  },
  // 시재금 관리 검색 State
  vaultCashSearchParams: {
    ...baseSearchParams,
  },
  vaultCashPage: 1,

  vaultCashHqIdx: 0,

  // ========== Action ==========
  // 시재금 관리 콤보 변경
  setVaultCashHQBranchCombo: (key, value) => {
    set((state) => {
      const updates = {
        vaultCashHQBranchCombo: {
          ...state.vaultCashHQBranchCombo,
          [key]: value,
        },
      };
      // 시재금 관리 콤보 변경 시 추가로 검색 조건도 변경
      if (key === "selected_hq_info") {
        updates.vaultCashSearchParams = {
          ...state.vaultCashSearchParams,
          hq_ids: [value.hq_id],
        };
      }

      if (key === "selected_branch_info") {
        updates.vaultCashSearchParams = {
          ...state.vaultCashSearchParams,
          // branch_ids(전체)면 spread 연산자로 복사
          branch_ids: value.branch_ids ? [...value.branch_ids] : [value.branch_id],
        };
      }

      return updates;
    });
  },

  // 시재금 관리 검색 조건 변경
  setSearchParams: (key, value) => {
    set((state) => ({
      vaultCashSearchParams: {
        ...state.vaultCashSearchParams,
        [key]: value,
      },
    }));
  },

  // Page 값 변경
  setPage: (value) => {
    set({ vaultCashPage: value });
  },

  // Hq Index 값 변경
  setHqIdx: (value) => {
    set({ vaultCashHqIdx: value });
  },

  // 검색 조건 리셋
  resetSearchParams: () => {
    set({
      vaultCashHqIdx: 0,
      vaultCashHQBranchCombo: { ...baseHQBranchCombo },
      vaultCashSearchParams: { ...baseSearchParams },
    });
  },
}));
